import React from 'react';

const PrivacyPolicy = ({ onBack }) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0B0B10',
      color: '#FFFFFF',
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #0B0B10 0%, #16161D 100%)',
        borderBottom: '1px solid rgba(255, 138, 61, 0.2)',
        padding: '1rem 1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <button
          onClick={onBack}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#FF8A3D',
            fontSize: '1.5rem',
            cursor: 'pointer',
            padding: '0.25rem'
          }}
        >
          ←
        </button>
        <h1 style={{ fontSize: '1.25rem', fontWeight: 700, margin: 0 }}>
          Privacy Policy
        </h1>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '2rem 1.5rem',
        lineHeight: '1.8',
      }}>
        <p style={{ color: '#8b9cb3', marginBottom: '2rem' }}>Last updated: February 19, 2026</p>

        <Section title="Overview">
          Runrora ("we", "our", or "us") is a community platform for runners and triathletes.
          This Privacy Policy explains how we collect, use, and protect your information when you
          use the Runrora website and iOS app (collectively, the "Service").
        </Section>

        <Section title="Information We Collect">
          <BulletList items={[
            <><strong>Account information:</strong> When you create an account, we collect your name, email address, and password. If you sign in with Apple, we receive your name and email (or a relay email) from Apple.</>,
            <><strong>Profile information:</strong> You may optionally provide your city, race results, and other profile details.</>,
            <><strong>Race data:</strong> Race registrations, race strategies, checklists, travel details, and mantras you create within the Service.</>,
            <><strong>Community content:</strong> Posts, threads, and comments you create in community boards.</>,
            <><strong>Usage data:</strong> Interactions such as follows, claps, and feed activity.</>,
          ]} />
        </Section>

        <Section title="How We Use Your Information">
          <BulletList items={[
            'To provide and maintain the Service',
            'To display your profile to other users in the community',
            'To show relevant activity in your feed',
            'To connect you with race and city communities',
            'To communicate important updates about the Service',
          ]} />
        </Section>

        <Section title="Data Storage and Security">
          Your data is stored on secure servers hosted by Railway. Authentication tokens are stored
          securely using Keychain on iOS and localStorage on the web. Passwords are hashed using bcrypt
          and are never stored in plain text.
        </Section>

        <Section title="Third-Party Services">
          <BulletList items={[
            <><strong>Apple Sign-In:</strong> If you choose to sign in with Apple, we receive an identity token and optionally your name. Apple may provide a private relay email address.</>,
            <><strong>Railway:</strong> Our backend infrastructure is hosted on Railway.</>,
          ]} />
          We do not use any analytics, advertising, or tracking services.
        </Section>

        <Section title="Data Sharing">
          We do not sell, trade, or share your personal information with third parties. Your profile
          information (name, city, race results) is visible to other Runrora users as part of the
          community features.
        </Section>

        <Section title="Your Rights">
          <BulletList items={[
            'Access your personal data through your profile',
            'Update or correct your information in Settings',
            'Delete your account by contacting us at support@runrora.com',
            'Request a copy of your data by contacting us',
          ]} />
        </Section>

        <Section title="Data Retention">
          We retain your data for as long as your account is active. If you request account deletion,
          we will remove your personal data within 30 days, except where we are required to retain it
          by law.
        </Section>

        <Section title="Children's Privacy">
          The Service is not intended for children under 13. We do not knowingly collect personal
          information from children under 13.
        </Section>

        <Section title="Changes to This Policy">
          We may update this Privacy Policy from time to time. We will notify users of significant
          changes through the Service or via email.
        </Section>

        <Section title="Contact Us">
          If you have questions about this Privacy Policy, please contact us at{' '}
          <a href="mailto:support@runrora.com" style={{ color: '#FF8A3D' }}>support@runrora.com</a>.
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <h2 style={{ fontSize: '1.15rem', fontWeight: 600, color: '#FF8A3D', marginBottom: '0.75rem' }}>
      {title}
    </h2>
    <div style={{ color: '#c5cdd8' }}>{children}</div>
  </div>
);

const BulletList = ({ items }) => (
  <ul style={{ paddingLeft: '1.25rem', margin: '0.5rem 0' }}>
    {items.map((item, i) => (
      <li key={i} style={{ marginBottom: '0.5rem' }}>{item}</li>
    ))}
  </ul>
);

export default PrivacyPolicy;
